import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { navLinks } from "../mock";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("#home");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 10);
      const sections = navLinks.map((n) => n.href.slice(1));
      let current = "#home";
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 130) current = `#${id}`;
      }
      setActive(current);
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.getElementById(href.slice(1));
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div className="rainbow-bar h-1 w-full" />
      <div
        className={`w-full transition-all duration-300 ${
          scrolled ? "bg-white/95 backdrop-blur-md shadow-[0_1px_0_rgba(0,0,0,0.06)]" : "bg-white"
        }`}
      >
        <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between h-[76px]">
          <button onClick={() => scrollTo("#home")} aria-label="Rainbow Worldwide home" className="shrink-0">
            <Logo className="h-9 sm:h-12" />
          </button>

          <nav className="hidden lg:flex items-center gap-9">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className={`nav-link font-medium text-[15px] text-charcoal hover:text-brand ${
                  active === link.href ? "active text-brand" : ""
                }`}
              >
                {link.label}
              </button>
            ))}
          </nav>

          <div className="hidden lg:block">
            <button onClick={() => scrollTo("#contact")} className="btn-primary">
              Discuss Your Stand
            </button>
          </div>

          <button className="lg:hidden text-charcoal" onClick={() => setOpen(!open)} aria-label="Toggle menu">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden border-t border-gray-100 bg-white px-5 py-4 space-y-1">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className="block w-full text-left py-2.5 font-medium text-charcoal hover:text-brand"
              >
                {link.label}
              </button>
            ))}
            <button onClick={() => scrollTo("#contact")} className="btn-primary w-full justify-center mt-2">
              Discuss Your Stand
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
